import Vue from 'vue';

export default Vue.component('section-curve-divider', {
  template: require('./template.html'),
  name: 'section-curve-divider',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/shape-dividers/curve/index.js